export default {"src":"/_next/static/media/icon-play-bg-white.d9887d1b.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};